import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
import { PurchasePopup } from './components/PurchasePopup';
const PIXEL_ID = '1252242806993118';
function initMetaPixel() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const w = window as any;
  // Avoid double-initialization (e.g. React StrictMode double-invoke).
  if (w.fbq) {
    try {
      w.fbq('track', 'PageView');
    } catch (e) {
      /* no-op */
    }
    return;
  }
  try {
    // Standard Meta Pixel bootstrap (manual injection to avoid fragile
    // third-party DOM assumptions that break inside sandboxed previews).
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const head = document.head || document.getElementsByTagName('head')[0];
    if (head) head.appendChild(script);
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  } catch (e) {
    // Pixel is non-critical; never let it crash the page.
    /* no-op */
  }
}
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <>
      <SalesPage data-id="element-0" />
      <PurchasePopup data-id="element-1" />
    </>;
}